import { reactionGetAllDescription as description } from './description';
import { getAll as execute } from './execute';

export { description, execute };
